import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirEpDrilldownService {
  constructor(private http: HttpClient) {}

  getEpDrilldownScreenData(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=amx4gr`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, String(value));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<any>(url, urlEncoded.toString(), {
      headers,
      withCredentials: true,
    });
  }
}
